import React from 'react'

const steps = [
  {
    number: "01",
    title: "Raccontaci il Tuo Evento",
    description: "Compila il form con i dettagli del tuo evento. Più informazioni ci dai, più precisa sarà la nostra proposta."
  },
  {
    number: "02",
    title: "Ricevi una Proposta su Misura",
    description: "Il nostro team di esperti creerà un progetto personalizzato e un preventivo dettagliato, senza impegno."
  },
  {
    number: "03",
    title: "Allestimento e Ritiro Senza Pensieri",
    description: "Consegniamo, posizioniamo le piante secondo il progetto e, a fine evento, veniamo a ritirare tutto noi."
  }
]

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-brand-subtle-bg scroll-mt-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Semplice, in 3 Passi</h2>
          <p className="text-lg text-brand-text/70 max-w-2xl mx-auto">Il nostro processo è pensato per essere facile e trasparente, dall'inizio alla fine.</p>
        </div>
        <div className="relative">
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-green/10" aria-hidden="true"></div>
          <div className="relative grid md:grid-cols-3 gap-12">
            {steps.map((step) => (
              <div key={step.number} className="bg-white p-8 rounded-lg border border-gray-200/80 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                <span className="text-6xl font-serif font-bold text-brand-green/10 mb-6 block">{step.number}</span>
                <h3 className="text-2xl font-semibold text-brand-green mb-3">{step.title}</h3>
                <p className="text-brand-text/70 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks